$(document).ready(function () {
    function getSavedSlide(key) {
        return parseInt(localStorage.getItem(key)) || 0;
    }

    function saveSlide(key, index) {
        localStorage.setItem(key, index);
    }

    const swipersConfig = {
        '#main_slider': {
            autoHeight: false,
            slidesPerView: 1,
            spaceBetween: 16,
            watchSlidesProgress: true,
            loop: true,
            autoplay: true,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
            lazy: { enabled: false },
            navigation: {
                nextEl: '#main_slider .swiper-pagination--next',
                prevEl: '#main_slider .swiper-pagination--prev',
            },
            pagination: {
                el: '#main_slider .swiper-dots',
                clickable: true,
                type: 'bullets',
                bulletClass: 'bullet',
                bulletActiveClass: 'bullet-active',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                    enablePauseOnHover(swiper);
                    imagesLazyLoad();
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    if (typeof lazyLoadImages === "function") {
                        lazyLoadImages(swiper.el);
                    }
                },
            },
        },

        '.swiper-container-1': {
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 0,
            watchSlidesProgress: true,
            loop: true,
            autoplay: false,
            lazy: { enabled: false },
            navigation: {
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoad();
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    if (typeof lazyLoadImages === "function") {
                        lazyLoadImages(swiper.el);
                    }
                },
            },
        },

        '.swiper-container-2' : {
            autoHeight: false,
            slidesPerView: 1,
            spaceBetween: 16,
            watchSlidesProgress: true,
            loop: true,
            lazy: {
                enabled: false,
            },
            breakpoints: {
                450: {
                    slidesPerView: 1.4,
                },
                640: {
                    slidesPerView: 2,
                },
                960: {
                    slidesPerView: 3,
                },
                1240: {
                    slidesPerView: 4,
                }
            },
            navigation: {
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoad();
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    if (typeof lazyLoadImages === "function") {
                        lazyLoadImages(swiper.el);
                    }
                },
            },
        },
        '.swiper-container-4' : {
            autoHeight: true,
            slidesPerView: 4,  // Количество видимых слайдов
            spaceBetween: 16,  // Отступ между слайдами
            watchSlidesProgress: true,
            loop: true,        // Бесконечный режим
            lazy: {
                enabled: false,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.8,
                },
                600: {
                    slidesPerView: 2.6,
                },
                860: {
                    slidesPerView: 3.6,
                },
                960: {
                    slidesPerView: 3.2,
                },
                1440: {
                    slidesPerView: 4,
                },
            },
            navigation: {      // Настраиваем кнопки навигации
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoad();
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    if (typeof lazyLoadImages === "function") {
                        lazyLoadImages(swiper.el);
                    }
                },
            },
        },
        '.swiper-container-5' : {
            autoHeight: false,
            slidesPerView: 5,  // Количество видимых слайдов
            spaceBetween: 16,  // Отступ между слайдами
            loop: true,        // Бесконечный режим
            watchSlidesProgress: true,
            lazy: {
                enabled: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.8,
                },
                768: {
                    slidesPerView: 2.3,
                },
                1024: {
                    slidesPerView: 3.3,
                },
                1324: {
                    slidesPerView: 4.3,
                },
                1440: {
                    slidesPerView: 5,
                },
            },
            navigation: {      // Настраиваем кнопки навигации
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoad();
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    if (typeof lazyLoadImages === "function") {
                        lazyLoadImages(swiper.el);
                    }
                },
            },
        },
        '.swiper-container-5-new' : {
            autoHeight: false,
            slidesPerView: 5,  // Количество видимых слайдов
            spaceBetween: 16,  // Отступ между слайдами
            loop: true,        // Бесконечный режим
            watchSlidesProgress: true,
            a11y: {
                enabled: true,
                slideRole: 'listitem', // Добавление правильной роли для слайдов
                containerRole: 'region', // Роль для контейнера
                prevSlideMessage: 'Предыдущий слайд',
                nextSlideMessage: 'Следующий слайд',
            },
            lazy: {
                enabled: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.8,
                },
                600: {
                    slidesPerView: 2.6,
                },
                860: {
                    slidesPerView: 3.6,
                },
                960: {
                    slidesPerView: 4.25,
                },
                1440: {
                    slidesPerView: 5,
                },
            },
            navigation: {      // Настраиваем кнопки навигации
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoad();
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    if (typeof lazyLoadImages === "function") {
                        lazyLoadImages(swiper.el);
                    }
                },
            },
        },
        '.swiper-container-5-shops' : {
            autoHeight: false,
            slidesPerView: 5,  // Количество видимых слайдов
            spaceBetween: 16,  // Отступ между слайдами
            watchSlidesProgress: true,
            loop: true,        // Бесконечный режим
            lazy: {
                enabled: false,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.8,
                },
                600: {
                    slidesPerView: 2.6,
                },
                860: {
                    slidesPerView: 3.6,
                },
                960: {
                    slidesPerView: 4.25,
                },
                1440: {
                    slidesPerView: 5,
                },
            },
            navigation: {      // Настраиваем кнопки навигации
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoad();
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    if (typeof lazyLoadImages === "function") {
                        lazyLoadImages(swiper.el);
                    }
                },
            },
        },
        '.swiper-container-5-view' : {
            autoHeight: false,
            slidesPerView: 5,  // Количество видимых слайдов
            spaceBetween: 16,  // Отступ между слайдами
            loop: true,        // Бесконечный режим
            watchSlidesProgress: true,
            lazy: {
                enabled: false,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.8,
                },
                600: {
                    slidesPerView: 2.6,
                },
                860: {
                    slidesPerView: 3.6,
                },
                960: {
                    slidesPerView: 4.25,
                },
                1440: {
                    slidesPerView: 5,
                },
            },
            navigation: {      // Настраиваем кнопки навигации
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoad();
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    if (typeof lazyLoadImages === "function") {
                        lazyLoadImages(swiper.el);
                    }
                },
            },
        },
        '.swiper-container-category' : {
            autoHeight: false,
            slidesPerView: 8,  // Количество видимых слайдов
            spaceBetween: 16,  // Отступ между слайдами
            watchSlidesProgress: true,
            loop: true,
            lazy: {
                enabled: false,
            },
            autoplay: {
                delay: 4000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
                stopOnLastSlide: false,
                waitForTransition: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 2.3,
                },
                600: {
                    slidesPerView: 3.3,
                },
                768: {
                    slidesPerView: 4.3,
                },
                1024: {
                    slidesPerView: 6.3,
                },
                1324: {
                    slidesPerView: 8,
                }
            },
            navigation: {
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoad();
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    if (typeof lazyLoadImages === "function") {
                        lazyLoadImages(swiper.el);
                    }
                },
            },
        },
        '.partners-banners' : {
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 15,
            watchSlidesProgress: true,
            loop: true,
            autoplay: {
                delay: 4000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
                stopOnLastSlide: false,
                waitForTransition: true,
            },
            lazy: {
                enabled: false,
            },
            navigation: {
                nextEl: '.swiper-pagination--next',
                prevEl: '.swiper-pagination--prev',
            },
            pagination: {
                el: '.swiper-pagination--val',
                type: 'custom',
            },
            on: {
                init: function(swiper) {
                    updateSwiperCustomPagination(swiper);
                    imagesLazyLoad();
                },
                slideChange: function (swiper) {
                    updateSwiperCustomPagination(swiper);
                    if (typeof lazyLoadImages === "function") {
                        lazyLoadImages(swiper.el);
                    }
                },
            },
        },
    };

    const initSwiper = (selector, config) => {
        const storageKey = 'swiper_last_' + selector;

        config.initialSlide = getSavedSlide(storageKey);

        const oldEvents = config.on || {};

        config.on = {
            ...oldEvents,

            slideChange: function (swiper) {
                saveSlide(storageKey, swiper.realIndex);

                if (typeof oldEvents.slideChange === "function") {
                    oldEvents.slideChange(swiper);
                }
            }
        };

        return new Swiper(selector, config);
    };

    const observerOptions = {
        root: null,
        rootMargin: '50px',
        threshold: 0.1
    };

    Object.keys(swipersConfig).forEach(selector => {
        const element = document.querySelector(selector);
        if (element) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        initSwiper(selector, swipersConfig[selector]);
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(element);
        }
    });

    let swiperCarousel5New = {destroyed: true};
    function swiperCarousel5NewReinit(slides, tag = 'all') {
        let swiperSelector = '.swiper-container-5-new';

        if(swiperCarousel5New.destroyed !== true) {
            swiperCarousel5New.destroy();
        }

        applySliderFilter(swiperSelector, slides, tag);

        initSwiper(swiperSelector, swipersConfig[swiperSelector]);
    }
    function applySliderFilter(swiperSelector, slides, tag = 'all') {
        let slidesWrapperEl = document.querySelector(swiperSelector + ' .swiper-wrapper');

        slidesWrapperEl.innerHTML = '';
        for(let i in slides) {
            let slide = slides[i];

            if(tag === 'all' || slide.tags.indexOf(tag) > -1) {
                slidesWrapperEl.insertAdjacentHTML('beforeend', slide.banner);
            }
        }
    }

    // Only initialize novelties slider if the data exists
    if (typeof noveltiesSlides !== 'undefined' && noveltiesSlides.length > 0) {
        swiperCarousel5NewReinit(noveltiesSlides);

        let swiperTags = document.querySelectorAll('.js-swiper-tags [data-tag]');
        swiperTags.forEach(function (swiperTag){
            swiperTag.addEventListener('click', function(e){
                let tagElement = e.currentTarget,
                    tag = tagElement.getAttribute('data-tag');

                swiperCarousel5NewReinit(noveltiesSlides, tag);

                tagElement.classList.add('uk-active');
                tagElement.parentNode.querySelectorAll('[data-tag]:not([data-tag="'+tag+'"])').forEach(function(sibling){
                    sibling.classList.remove('uk-active');
                });

            })
        });
    }

    function updateVisibleSlides(swiper) {
        swiper.slides.forEach((slide) => slide.classList.remove('active-visible'));
        const visibleSlides = swiper.el.querySelectorAll('.swiper-slide-visible');
        visibleSlides.forEach((slide) => {
            slide.classList.add('active-visible');
        });
    }

    function updateSwiperCustomPagination(swiper, paginatorSelector = '.swiper-pagination--val') {
        if (!swiper.slides || swiper.slides.length < 2) {
            const paginatorParent = swiper.el.querySelector(paginatorSelector)?.parentElement;
            if (paginatorParent) {
                paginatorParent.style.display = 'none';
            }
        } else {
            const current = swiper.realIndex + 1;
            const total = swiper.slides.length;
            const paginatorElement = swiper.el.querySelector(paginatorSelector);

            if (paginatorElement) {
                paginatorElement.parentElement.style.display = 'flex';
                paginatorElement.innerText = `${current} / ${total}`;
            }
        }
    }

    function enablePauseOnHover(swiper) {
        swiper.el.addEventListener('mouseenter', () => swiper.autoplay?.stop?.());
        swiper.el.addEventListener('mouseleave', () => swiper.autoplay?.start?.());
    }

    window.enablePauseOnHover = enablePauseOnHover;
    window.updateSwiperCustomPagination = updateSwiperCustomPagination;
});
